import { Icon, LinkButton } from '@aibees/shared/components';
import { useParams, useSearchParams } from '@aibees/shared/router';
import { classnames } from '@aibees/shared/utils';
import { Typography, useTheme } from '@mui/material';
import { memo } from 'react';
import { useGetExportFileQuery } from '../../api/use-get-export-file-query-api';
import * as Styled from './styles';
import { ExportFileUrlParams, type ExportProps as Props } from './types';

export const Export = memo(({ className }: Props) => {
  const theme = useTheme();
  const params = useSearchParams<ExportFileUrlParams>();
  const { id } = useParams();
  const api = useGetExportFileQuery(id as string, params.workspaceId);

  return (
    <Styled.Wrapper
      className={classnames('ExportFile', className)}
      title={
        <Typography variant="h6">
          Click the link below to download the export file
        </Typography>
      }
      titleProps={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
      contentSx={{ textAlign: 'center' }}
    >
      <LinkButton
        variant="text"
        sx={{ textAlign: 'center' }}
        href={api.data?.url}
        startIcon={
          <Icon color={theme.palette.grey[500]} size={16} name="download" />
        }
      >
        Download Report
      </LinkButton>
    </Styled.Wrapper>
  );
});

Export.displayName = 'Export';
